<ion-toolbar mode="md">
  <ion-searchbar
    placeholder="Search by name"
    mode="md"
    [(ngModel)]="search"
    (ionInput)="searching.emit($event.detail.value)"
  ></ion-searchbar>

  <ion-buttons slot="end">
    <ion-button
      disabled
      size="large"
      class="search-btn"
      (click)="showSearchBar()"
    >
      <ion-icon name="search-outline" slot="icon-only"></ion-icon>
    </ion-button>
  </ion-buttons>
</ion-toolbar>
